import http from './http';

export function getSyncDataByRecordID(query) {
  return http.get('/ProjectSyncDataLog/GetSyncDataByRecordID', query);
}
export function getSyncDataByRecordIdExport(query) {
  return http.get('/ProjectSyncDataLog/GetSyncDataByRecordIdExport', query);
}